var FIGURE = FIGURE || {};

// Disables headroom.js (initialized unconditionally by OffsetBaseResources/js/site.js).
// The delay must exceed headroom's own 100ms deferred attachEvent() call, or it
// re-attaches its scroll listener right after we destroy it.
setTimeout(function() {
	$("body").headroom("destroy");
}, 150);

FIGURE.shippingMessage = function() {
	var specialMessageModal = $.cookie('specialmessage');
	if (specialMessageModal == 'read') {
		return;
	} else {
		setTimeout(function(){
			$('#figureMessageModal').modal();
		}, 3000);	
	}	
	$('#figureMessageModal').on('hide.bs.modal', function (event) {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
	$('#figureMessageModal a').click(function() {
		$.cookie('specialmessage', 'read', { path: '/' });
	});
}();
